import * as React from 'react';

import type { IconProps } from './types';

export const FolderCourse = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      fill="none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g fill={color}>
        <path
          d="M6.404 1.35h1.402c.594 0 1.098 0 1.52.043.446.043.86.139 1.256.37.396.23.685.54.945.906.244.345.495.783.789 1.299l.321.561a7.6 7.6 0 0 0 .34.564c.024.035.05.068.08.098h.003l.012.004c.036.01.074.016.111.018.14.014.327.015.657.015h1.544c1.514 0 2.736 0 3.696.128.997.135 1.836.421 2.503 1.089.667.666.954 1.506 1.087 2.502.1.738.123 1.631.128 2.692A8 8 0 1 0 11.49 22.95H8.616c-1.514 0-2.736 0-3.696-.13-.997-.133-1.837-.42-2.503-1.087-.667-.667-.954-1.506-1.087-2.503-.13-.96-.13-2.182-.13-3.696v-8.98c0-.996 0-1.825.089-2.484.093-.696.3-1.324.804-1.828s1.131-.71 1.827-.804c.66-.088 1.488-.088 2.484-.088z"
          fill={color}
        />

        <path
          d="M17 12.484a4.672 4.672 0 0 1 4.667 4.667A4.672 4.672 0 0 1 17 21.817a4.672 4.672 0 0 1-4.667-4.666A4.672 4.672 0 0 1 17 12.484zm0-1.333c-3.32 0-6 2.68-6 6s2.68 6 6 6 6-2.68 6-6-2.68-6-6-6zm0 4.666c-.738 0-1.333.596-1.333 1.334 0 .737.595 1.333 1.333 1.333s1.333-.596 1.333-1.333c0-.738-.595-1.334-1.333-1.334zm0-1.066c1.32 0 2.4 1.08 2.4 2.4 0 1.32-1.08 2.4-2.4 2.4-1.32 0-2.4-1.08-2.4-2.4 0-1.32 1.08-2.4 2.4-2.4zm0-1.2a3.595 3.595 0 0 0-3.6 3.6c0 1.992 1.608 3.6 3.6 3.6s3.6-1.608 3.6-3.6-1.608-3.6-3.6-3.6z"
          fill={color}
        />
      </g>
    </svg>
  )
);

export default FolderCourse;
